<template lang="pug">
    div
        Button(shape="circle" icon="md-information-circle" size="small" type="info" ghost @click="modal = true") {{ infoBtnText }}
            Modal(
              v-model="modal"
              title="How does scheme works with domain and wildcard?"
              width="768"
              footer-hide=true)
                img(src="/static/img/wildcardScheme.svg" width="100%")
</template>
<script>
export default {
    name: "ExplainScheme",
    props: { infoBtnText: { type: String, default: "Wildcard" } },
    data() {
        return { modal: false };
    },
    methods: {},
    computed: {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainScheme.vue